import ThemeProvider from "react-bootstrap/ThemeProvider";
import { BrowserRouter } from "react-router-dom";
import { ModalProvider } from "@hooks/contexts/modal-context";
import { SidebarCollapseProvider } from "@hooks/contexts/SidebarCollapseContext";
import { TopbarCollapseProvider } from "@hooks/contexts/TopbarCollapseContext";
import { ToastContainer } from "react-toastify";
// @ts-ignore
import "react-toastify/dist/ReactToastify.css";
import { config } from "config";
import { AuthProvider } from "@hooks/contexts/auth-context";
import { AppContent } from "AppContent";

function App() {
  // --- Set the Platform Name --- //
  document.title = config.appName;

  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      <BrowserRouter>
        <AuthProvider>
          <ModalProvider>
            <TopbarCollapseProvider>
              <SidebarCollapseProvider>
                <AppContent />
              </SidebarCollapseProvider>
            </TopbarCollapseProvider>
          </ModalProvider>
          <ToastContainer />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
